/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Search_CtaInputs */

const en_salary_search_cta = /** @type {(inputs: Salary_Search_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Salaries`)
};

const de_salary_search_cta = /** @type {(inputs: Salary_Search_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehälter suchen`)
};

const fr_salary_search_cta = /** @type {(inputs: Salary_Search_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher les salaires`)
};

const es_salary_search_cta = /** @type {(inputs: Salary_Search_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar salarios`)
};

const it_salary_search_cta = /** @type {(inputs: Salary_Search_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca stipendi`)
};

const nl_salary_search_cta = /** @type {(inputs: Salary_Search_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salarissen zoeken`)
};

const pl_salary_search_cta = /** @type {(inputs: Salary_Search_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyszukaj wynagrodzenia`)
};

const fi_salary_search_cta = /** @type {(inputs: Salary_Search_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae palkkoja`)
};

const da_salary_search_cta = /** @type {(inputs: Salary_Search_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg lønninger`)
};

const sv_salary_search_cta = /** @type {(inputs: Salary_Search_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök löner`)
};

/**
* | output |
* | --- |
* | "Search Salaries" |
*
* @param {Salary_Search_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_search_cta = /** @type {((inputs?: Salary_Search_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Search_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_search_cta(inputs)
	if (locale === "fr") return fr_salary_search_cta(inputs)
	if (locale === "es") return es_salary_search_cta(inputs)
	if (locale === "it") return it_salary_search_cta(inputs)
	if (locale === "nl") return nl_salary_search_cta(inputs)
	if (locale === "pl") return pl_salary_search_cta(inputs)
	if (locale === "fi") return fi_salary_search_cta(inputs)
	if (locale === "da") return da_salary_search_cta(inputs)
	if (locale === "sv") return sv_salary_search_cta(inputs)
	return en_salary_search_cta(inputs)
});